import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: null,
  // dsn: "https://91e751e1734213ac9cf5e1bbfc324585@o1093088.ingest.us.sentry.io/4509414709329920",
  sendDefaultPii: true
});
